import { Asset } from '@/api/generatedApi';
import { StyledList, StyledListItem } from '@/components/AssetsPage/PopoverList';
import { useDownloadAsset } from '@/hooks/useDownloadAsset';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { Download as DownloadIcon } from '@mui/icons-material';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import LabelIcon from '@mui/icons-material/Label';
import { Divider, ListItemIcon, ListItemText } from '@mui/material';

export const AssetActionsMenuContent = ({
  asset,
  onClose,
  onMoveClick,
  onLabelClick,
  sx,
}: {
  asset: Asset;
  onClose: () => void;
  onMoveClick: (asset: Asset) => void;
  onLabelClick?: (asset: Asset) => void;
  sx?: object;
}) => {
  const { permissions } = useGetCurrentUser();
  const { downloadAsset } = useDownloadAsset();

  const handleDownloadClick = async () => {
    onClose();
    await downloadAsset(asset);
  };

  const handleMoveClick = () => {
    onMoveClick(asset);
    onClose();
  };

  const handleLabelClick = () => {
    onLabelClick?.(asset);
    onClose();
  };

  return (
    <StyledList sx={sx}>
      <Divider />
      <StyledListItem onClick={() => void handleDownloadClick()}>
        <ListItemIcon>
          <DownloadIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>Download</ListItemText>
      </StyledListItem>
      {permissions.canCreateFolders && (
        <StyledListItem onClick={handleMoveClick}>
          <ListItemIcon>
            <DriveFileMoveIcon sx={{ fontSize: '18px' }} />
          </ListItemIcon>
          <ListItemText>Move Asset</ListItemText>
        </StyledListItem>
      )}
      {onLabelClick && (
        <StyledListItem onClick={handleLabelClick}>
          <ListItemIcon>
            <LabelIcon sx={{ fontSize: '18px' }} />
          </ListItemIcon>
          <ListItemText>Label</ListItemText>
        </StyledListItem>
      )}
    </StyledList>
  );
};
